import { render, staticRenderFns } from "./BookShelfIcon.vue?vue&type=template&id=ec3d011a&scoped=true&"
import script from "./BookShelfIcon.vue?vue&type=script&lang=js&"
export * from "./BookShelfIcon.vue?vue&type=script&lang=js&"
import style0 from "./BookShelfIcon.vue?vue&type=style&index=0&id=ec3d011a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3d011a",
  null
  
)

export default component.exports